<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-12 class="text-left fw-500">12. Amendments to Terms and Conditions</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-12" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Right to Amend: RCPAY Virtual Account reserves the right to amend these terms at any time.</li>
                        <li>Notification of Changes: Account Holders will be notified of any changes via email or the RCPAY Virtual Account website at least 30 days prior to the changes taking effect.</li>
                        <li>Acceptance of Changes: Continued use of the VA service after the effective date of changes constitutes acceptance of the new terms and conditions.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-12',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>